// extracted by mini-css-extract-plugin
module.exports = {"game_manager-qr":"GameManager_game_manager-qr__1ezUN","game_manager-qr_in":"GameManager_game_manager-qr_in__3QkCl","game_manager-qr_body":"GameManager_game_manager-qr_body__1XccY"};